import { TMkStep } from '@typescript'
import { EMkDepositRCIStepName, EMkRCIDepositsAction, IMkAnyAccountField, IMkRCIDepositsDraft, IMkRCIDepositsError, TMkRCIDepositsAction } from '../types'

export const setRCIDepositsDraft = (rciDepositsDraft: IMkRCIDepositsDraft): TMkRCIDepositsAction => ({
  type: EMkRCIDepositsAction.SET_DRAFT,
  payload: rciDepositsDraft,
})

export const updateField = (step: TMkStep, fieldName: string, fieldValue: IMkAnyAccountField['value'], fieldType: string): TMkRCIDepositsAction => ({
  type: EMkRCIDepositsAction.UPDATE_FIELD,
  payload: {
    stepName: step.name as EMkDepositRCIStepName,
    fieldName,
    fieldValue,
    fieldType,
  },
})

export const setError = (error: IMkRCIDepositsError): TMkRCIDepositsAction => ({
  type: EMkRCIDepositsAction.SET_ERROR,
  payload: error,
})
